import React from 'react';
import { Icon } from './Icon';
import type { IconName } from './Icon';

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?:
    | 'primary'
    | 'secondary'
    | 'ghost'
    | 'danger'
    | 'danger-ghost'
    | 'subtle';
  size?: 'sm' | 'lg';
  iconOnly?: boolean;
  leftIcon?: IconName;
  rightIcon?: IconName;
  loading?: boolean;
  children?: React.ReactNode;
  className?: string;
}

export function Button({
  variant = 'secondary',
  size,
  iconOnly,
  leftIcon,
  rightIcon,
  loading,
  children,
  className = '',
  ...rest
}: ButtonProps) {
  const cls = ['btn', 'btn-' + variant];
  if (size === 'sm') cls.push('btn-sm');
  if (size === 'lg') cls.push('btn-lg');
  if (iconOnly) cls.push('btn-icon');
  if (className) cls.push(className);
  const onAccent = variant === 'primary' || variant === 'danger';
  return (
    <button
      className={cls.join(' ')}
      disabled={loading || rest.disabled}
      {...rest}
    >
      {loading ? (
        <span className={'spinner sm' + (onAccent ? ' on-accent' : '')} />
      ) : (
        leftIcon && <Icon name={leftIcon} size={size === 'sm' ? 15 : 16} />
      )}
      {children}
      {!loading && rightIcon && (
        <Icon name={rightIcon} size={size === 'sm' ? 15 : 16} />
      )}
    </button>
  );
}

export default Button;
